export enum ShowStatus {
  Visible = 'visible',
  Hidden = 'hidden',
}

export enum UserNotificationCategory {
  CalendarDisconnected = 'calendar_disconnected',
  CalendarMissingPermissions = 'calendar_missing_permissions',
}

export interface UserNotification {
  id: number;
  showStatus: ShowStatus;
  category: UserNotificationCategory;
}
